import { arrayOf, string, func, shape } from 'prop-types';
import * as styles from './styles/styles.module.scss';

const ToggleRadioButtons = ({ options, handleOnChange, activeOption }) => {
  return (
    <div className={styles.container}>
      {options.map(option => {
        return (
          <div className={styles.optionContainer} key={option.value}>
            <input
              value={option.value}
              onChange={handleOnChange}
              className={styles.radioButton}
              id={option.value}
              name={option.name}
              type="radio"
              checked={activeOption === option.value}
            />
            <label htmlFor={option.value} className={styles.label}>
              <div className={styles.innerLabel}>{option.label}</div>
            </label>
          </div>
        );
      })}
    </div>
  );
};

ToggleRadioButtons.propTypes = {
  options: arrayOf(shape({ label: string, value: string })),
  handleOnChange: func,
  activeOption: string
};

ToggleRadioButtons.defaultProps = {
  options: [],
  handleOnChange: () => {},
  activeOption: ''
};

export default ToggleRadioButtons;
